/*
 * @Author       : 蔡传明
 * @Date         : 2021-06-25 16:03:06
 * @LastEditors: liuzhenxing liuzhenxing@lixiang.com
 * @LastEditTime: 2025-03-12 16:15:51
 * @FilePath     : /club/src-client/service/ArticleService/ArticleService.ts
 */
import HttpClient from '@chehejia/club-lib/lib/httpUtils/HttpClient';
import Constants from '../../enum/Constants';

export default class ArticleService {
    // 获取文章列表
    public static getArticleList(pageNo: number, pageSize: number, config: any) {
        return HttpClient.get(Constants.getArticle(), `/mylist/page/${pageNo}/pagesize/${pageSize}`, config).then((data) => {
            return data;
        });
    }

    // 删除指定文章
    public static deleteArticle(ID: number, config: any) {
        return HttpClient.post(Constants.getArticle(), `/offline/${ID}`, {}, config).then((data) => {
            return data;
        });
    }

    // 定时-立刻发布文章

    public static immediatelyPubArticle(ID: number, config: any) {
        return HttpClient.post(Constants.getArticle(), `/immediate/${ID}`, {}, config).then((data) => {
            return data;
        });
    }

    // 获取文章详情
    public static getDetail(ID: number, config: any) {
        return HttpClient.get(Constants.getArticle(), `/detail/${ID}`, config).then((data) => {
            return data;
        });
    }

    // 创建文章&&修改文章（是否传id）

    public static createOrUpdateArticle(param, config) {
        return HttpClient.post(Constants.getArticle(), '/release', param, config).then((data) => {
            return data;
        });
    }

    // 保存文章草稿&&修改保存草稿
    public static saveDraft(param, config) {
        return HttpClient.post(Constants.getArticle(), '/draft', param, config).then((data) => {
            return data;
        });
    }

    // 视频文章发布
    public static videoRelease(param, config?) {
        return HttpClient.post(Constants.getVideo(), '/pa/release', param, config).then((data) => {
            return data;
        });
    }
    // 获取手机预览二维码
    public static getPhonePreviewQrcode(productId, config?) {
        return HttpClient.post(Constants.getQuestion(), `/barcodes/pa/${productId}`, config).then((data) => {
            return data;
        });
    }

}
